module.exports = __webpack_public_path__ + "img/header.109e769e.jpg";